const base64Converter = {
	StringToBase64: (str: string) => btoa(unescape(encodeURIComponent(str))),
	Base64ToString: (b64: string) => decodeURIComponent(escape(atob(b64)))
};

export default base64Converter;
